var product_personalizer_app = null;

document.addEventListener("DOMContentLoaded", () => {
  product_personalizer_app = new Vue({
    el: "#product_personalizer_app_2",
    delimiters: ["vue{", "}"],
    data: {
      preview_img_url: null,
      visible: false,
      img: {
        left: "https://cdn.shopify.com/s/files/1/0101/2750/7515/files/gp-101-left.jpg?v=1604591798",
        right:
          "https://cdn.shopify.com/s/files/1/0101/2750/7515/files/gp-101-right.jpg?v=1604591798",
      },
      max_chr: 20,
      order_type: "standard",
      engraving_type: "standard",
      engraving_lines: "one",
      engravings: [
        {
          active: true,
          text: {
            line_1: "Engraving Text",
            line_2: "Engraving line 2",
          },
          selected_font: "block",
          hand: "right",
          gift_wrap: false,
          gift_wrap_message: "",
        },
      ],
      phone_number: "",
    },

    watch: {
      order_type(newVal, oldVal) {
        if (newVal === "bulk" && oldVal !== "bulk") {
          this.engraving_type = "standard";
          this.padEngravingsToMin(); // bulk always 10
        }
        if (newVal === "standard" && oldVal !== "standard") {
          // reset engravings to just 1 item
          this.engravings = [
            {
              active: true,
              text: {
                line_1: "Engraving Text",
                line_2: "Engraving line 2",
              },
              selected_font: "block",
              hand: "right",
              gift_wrap: false,
              gift_wrap_message: "",
            },
          ];
          // ❌ remove padEngravingsToMin() here
        }
      },
    },


    methods: {
      remove_preview_image() {
        const fileInput =
          this.engraving_type == "handwriting"
            ? this.$refs.HandwritingUpload
            : this.$refs.LogoUpload;
        fileInput.value = "";
        this.preview_img_url = null;
      },

      upload_preview_image() {
        const fileInput =
          this.engraving_type == "handwriting"
            ? this.$refs.HandwritingUpload
            : this.$refs.LogoUpload;

        const file = fileInput.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            this.preview_img_url = reader.result;
          };
          reader.readAsDataURL(file);
        } else {
          this.preview_img_url = null;
        }
      },

      show() {
        this.visible = true;
      },
      hide() {
        this.visible = false;
      },
      setImage(left_img, right_img) {
        this.img.left = left_img;
        this.img.right = right_img;
      },

      padEngravingsToMin(count = 10) {
        while (this.engravings.length < count) {
          this.engravings.push({
            active: true,
            text: {
              line_1: "Engraving Text",
              line_2: "Engraving line 2",
            },
            selected_font: "block",
            hand: "right",
            gift_wrap: false,
            gift_wrap_message: "",
          });
        }
      },
      setMax(max_chr) {
        this.max_chr = max_chr;
      },

      add_quantity() {
        this.order_type = "bulk";
        this.engravings.push({
          active: true,
          text: {
            line_1: "Engraving Text",
            line_2: "Engraving line 2",
          },
          selected_font: "block",
          hand: "right",
          gift_wrap: false,
          gift_wrap_message: "",
        });
        this.padEngravingsToMin(); // Ensure always 10
      },

      remove_pen(index) {
        this.engravings.splice(index, 1);
        this.padEngravingsToMin();
      },

      remove_quantity() {
        if (this.engravings.length > 1) {
          this.engravings.splice(this.engravings.length - 1, 1);
          this.padEngravingsToMin();
        }
      },

      add_to_cart() {
        const add_url = window.Shopify.routes.root + "cart/add.js";
        const {
          order_type,
          engraving_type,
          engraving_lines,
          engravings,
          phone_number,
        } = this;
        // Get the initial variant ID on page load
        let currentVariantID = document.querySelector("input[name='id']")?.value;

          // 🔎 get inventory from hidden field
        let availableQty = parseInt(document.getElementById("variant-inventory")?.value || 0);

        // 🔎 required quantity
        const requiredQty = order_type === "standard" ? 1 : engravings.length;

        // ✅ Prevent add-to-cart if stock is not enough
        if (requiredQty > availableQty) {
          alert(`Sorry, only ${availableQty} in stock!`);
          return;
        }

        const formData = new FormData();

        formData.append("form_type", "product");
        formData.append("utf8", "✓");
        formData.append(`items[0][id]`, currentVariantID);
        formData.append(`items[0][properties][Phone Number]`, phone_number);
        formData.append(`items[0][quantity]`, requiredQty);
        formData.append(`items[0][properties][Order Type]`, order_type);
        formData.append(`items[0][properties][Engraving Type]`, engraving_type);

        if (engraving_type === "standard") {
          if (order_type === "standard") {
            formData.append(
              `items[0][properties][Writing Hand]`,
              engravings[0].hand
            );
            formData.append(
              `items[0][properties][Fonts]`,
              engravings[0].selected_font
            );
            formData.append(
              `items[0][properties][Engraving Lines]`,
              engraving_lines
            );
            formData.append(
              `items[0][properties][Line 1]`,
              engravings[0].text.line_1
            );
            if (engravings[0].gift_wrap) {
              formData.append(
                `items[0][properties][Gift wrap]`,
                "Yes, gift wrap this item, please!"
              );
              if (engravings[0].gift_wrap_message.length) {
                formData.append(
                  `items[0][properties][Gift wrap Message]`,
                  engravings[0].gift_wrap_message
                );
              }
            }
            if (engraving_lines === "two") {
              formData.append(
                `items[0][properties][Line 2]`,
                engravings[0].text.line_2
              );
            }
          }

          if (order_type === "bulk") {
            let csvContent =
              engraving_lines === "two"
                ? "Line 1, Line 2, Fonts, Writing Hand, Gift Wrap, Gift Wrap Message\n"
                : "Line 1, Fonts, Writing Hand, Gift Wrap, Gift Wrap Message\n";

            engravings.forEach((item) => {
              if (item.placeholder) return; // Skip placeholder rows
              if (engraving_lines === "two") {
                csvContent += `"${item.text.line_1}","${item.text.line_2}","${item.selected_font
                  }","${item.hand}","${item.gift_wrap ? "Yes" : "No"}","${item.gift_wrap_message || ""
                  }"\n`;
              } else {
                csvContent += `"${item.text.line_1}","${item.selected_font}","${item.hand
                  }","${item.gift_wrap ? "Yes" : "No"}","${item.gift_wrap_message || ""
                  }"\n`;
              }
            });

            const blob = new Blob([csvContent], { type: "text/csv" });
            formData.append(
              "items[0][properties][List of Names]",
              blob,
              "list-of-names.csv"
            );
          }
        }

        if (engraving_type !== "standard") {
          const fileInput =
            this.engraving_type == "handwriting"
              ? this.$refs.HandwritingUpload
              : this.$refs.LogoUpload;
          const temp_image_name =
            this.engraving_type.charAt(0).toUpperCase() +
            this.engraving_type.slice(1);
          formData.append(
            `items[0][properties][Writing Hand]`,
            engravings[0].hand
          );
          formData.append(
            `items[0][properties][${temp_image_name} Image]`,
            fileInput.files[0]
          );
        }
        if (order_type == "standard" && engraving_type == "standard") {
          formData.append(`items[1][id]`, 33974679361);
        }
        if (order_type == "standard" && engraving_type == "handwriting") {
          formData.append(`items[1][id]`, 43720420098187);
        }
        if (order_type == "bulk") {
          formData.append(`items[1][id]`, 43720420130955);
        }
        formData.append(`items[1][quantity]`, engravings.length);

        let gift_wrap_count = 0;
        engravings.forEach((item) => {
          if (item.gift_wrap) gift_wrap_count++;
        });

        if (gift_wrap_count) {
          formData.append(`items[2][id]`, 29369284481);
          formData.append(`items[2][quantity]`, gift_wrap_count);
        }

        fetch(add_url, {
          method: "POST",
          body: formData,
        })
          .then(async (response) => {
            if (response.status === 200) {
              monster_refresh();
            } else {
              const res = await response.json();
              alert(`Error: ${res.description}`);
            }
            return response;
          })
          .catch((error) => {
            alert("Something went wrong!");
            console.error("Error:", error);
          });
      },
    },
  });
  document.addEventListener("variant:change", function (event) {
    const variant = event.detail.variant;
    if (variant) {
      document.getElementById("variant-inventory").value = variant.inventory_quantity;
    }
  });
});
